import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type CategoriesToolbarProps = {
  onCreate: () => void;
  canCreate: boolean;
};

export function CategoriesToolbar({
  onCreate,
  canCreate,
}: CategoriesToolbarProps) {
  return (
    <div className="mb-2 flex flex-wrap items-center justify-between space-y-2">
      <div>
        <h2 className="font-bold text-2xl tracking-tight">ຫມວດຫມູ່</h2>
        <p className="text-muted-foreground text-sm">
          ຈັດການຫມວດຫມູ່ແບບຕົ້ນໄມ້ — ຫມວດຫຼັກ ແລະ ຫມວດຍ່ອຍ ສຳລັບຄ່າທຳນຽມ ແລະ ລາຍການສິນຄ້າ.
        </p>
      </div>
      {canCreate && (
        <Button onClick={onCreate}>
          <PlusIcon className="size-4" />
          ເພີ່ມຫມວດຫຼັກ
        </Button>
      )}
    </div>
  );
}
